var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 9.01804H9.89113L4.52387 14.4265L5.95708 15.8694L12.3431 9.44502L13.7764 7.9972L5.95708 0.125L4.52387 1.57282L9.89113 6.97637H1.78488e-07L0 9.01804Z","fill":"#F04A30"}));
}

Arrow.defaultProps = {"width":"14","height":"16","viewBox":"0 0 14 16","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
